import { ForestOwnerSearchPage } from '@features/ForestOwner/Search/SearchPage/ForestOwnerSearchPage'
import { forestOwnerSearchSchema } from '@services/queryOptions'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/search')({
  validateSearch: forestOwnerSearchSchema,
  loaderDeps: ({ search }) => search,
  component: ForestOwnerSearchPage,
  staticData: { breadcrumb: 'Skogeier' },
})
